/* global Q */
var validator = require("validator");
var cidr = require('../../deploynaut/js/cidr');
var _ = require('underscore');

var React = require("react");
const createReactClass = require("create-react-class");
const PropTypes = require("prop-types");

var VariableTable = require('../../deploynaut/js/variable_table.jsx');
var VariableEditor = require('../../deploynaut/js/variable_editor.jsx');
var HelpText = require('./HelpText.jsx');
var ToggleBox = require('../../deploynaut/js/components/ToggleBox.jsx');

var WhitelistComponent = createReactClass({

	getInitialState: function() {
		return {
			editing: false,
			Enabled: this.props.model.Enabled,
			Items: this.modelToArray(this.props.model.Items),
			ReadonlyItems: this.modelToArray(this.props.model.ReadonlyItems),
			NeedFullDeploy: this.props.model.NeedFullDeploy,
			SecurityID: this.props.model.InitialSecurityID,
			message: { type: 'success', body: '' },
			FullDeployNeededMessage: this.props.model.FullDeployNeededMessage
		};
	},

	modelToArray: function(model) {
		return _.map(_.keys(model), function(key) {
			return {
				variable: key,
				value: model[key]
			};
		});
	},

	startEditing: function() {
		this.setState({
			editing: true
		});
	},

	editingCancel: function() {
		this.setState({
			editing: false
		});
	},

	whitelistToggle: function() {
		this.editingCancel();
		if(this.state.Enabled) {
			this.disableWhitelist();
		} else {
			this.enableWhitelist();
		}
	},

	request: function(url, postData) {
		var self = this;
		return Q($.ajax({
			type: "POST",
			url: url,
			data: postData
		}))
		.then(function(data) {
			self.setState({
				Enabled: data.Enabled,
				editing: false,
				Items: self.modelToArray(data.Items),
				ReadonlyItems: self.modelToArray(data.ReadonlyItems),
				NeedFullDeploy: data.NeedFullDeploy,
				SecurityID: data.NewSecurityID,
				message: { type: 'success', body: data.Message }
			});
		})
		.fail(function(data) {
			self.setState({
				message: { type: 'danger', body: data.responseText }
			});
		});
	},

	enableWhitelist: function() {
		return this.request(
			this.props.model.EnableAction,
			{
				DispatcherSecurityID: this.state.SecurityID
			}
		);
	},

	disableWhitelist: function() {
		return this.request(
			this.props.model.DisableAction,
			{
				DispatcherSecurityID: this.state.SecurityID
			}
		);
	},

	editingSubmit: function(items) {
		// Convert the data back into associative array expected by the backend.
		var assocArray = {};
		for (var i = 0; i < items.length; i++) {
			assocArray[items[i].variable] = items[i].value;
		}

		return this.request(
			this.props.model.FormAction,
			{
				Details: JSON.stringify(assocArray),
				DispatcherSecurityID: this.state.SecurityID
			}
		);
	},

	render: function() {
		var form = null;
		if(this.state.Enabled) {
			form = (
				<EditForm
					startEditing={this.startEditing}
					editingCancel={this.editingCancel}
					editingSubmit={this.editingSubmit}
					editing={this.state.editing}
					Items={this.state.Items}
					ReadonlyItems={this.state.ReadonlyItems}
					NeedFullDeploy={this.state.NeedFullDeploy}
					message={this.state.message}
					FullDeployNeededMessage={this.state.FullDeployNeededMessage}
				/>
			);
		}

		return (
			<div className="row">
				<div className="col-md-7">
					<HelpText />
				</div>
				<div className="col-md-5">
					<ToggleBox
						className="whitelist"
						enabled={this.state.Enabled}
						pending={this.state.NeedFullDeploy}
						onChangeHandler={this.whitelistToggle}
						FullDeployNeededMessage={this.state.FullDeployNeededMessage}
					/>
				</div>
				<div className="col-md-12">
					{form}
				</div>
			</div>
		);
	}
});

var EditForm = createReactClass({

	propTypes: {
		startEditing: PropTypes.func.isRequired,
		editingCancel: PropTypes.func.isRequired,
		editingSubmit: PropTypes.func.isRequired,
		editing: PropTypes.bool.isRequired,
		Items: PropTypes.array.isRequired,
		ReadonlyItems: PropTypes.array.isRequired,
		NeedFullDeploy: PropTypes.bool.isRequired,
		message: PropTypes.shape({
			type: PropTypes.string,
			body: PropTypes.string
		}).isRequired,
		FullDeployNeededMessage: PropTypes.string
	},

	validateAddress: function(value) {
		if (validator.isIP(value) || cidr().test(value) || cidr.v6().test(value)) {
			return '';
		}
		return 'Only valid IP or CIDR permitted.';
	},

	render: function() {
		var message = '';
		if (this.props.message.body) {
			message = (
				<div className="whitelist-message">
					<div
						className={'alert alert-' + this.props.message.type}
						dangerouslySetInnerHTML={{__html:this.props.message.body}}
					/>
				</div>
			);
		}

		if (!this.props.editing) {
			return (
				<div className="whitelist-items">
					{message}
					<VariableTable
						variables={this.props.Items}
						readonlyVariables={this.props.ReadonlyItems}
						edit={this.props.startEditing}
						variableHeading="Address (IP or CIDR)"
						valueHeading="Comment"
					/>
				</div>
			);
		}
		return (
			<div className="whitelist-items">
				{message}
				<VariableEditor
					variables={this.props.Items}
					readonlyVariables={this.props.ReadonlyItems}
					submit={this.props.editingSubmit}
					cancel={this.props.editingCancel}
					variableHeading="Address (IP or CIDR)"
					valueHeading="Comment"
					validateVariable={this.validateAddress}
				/>
			</div>
		);
	}
});

module.exports = WhitelistComponent;
